import { CodeOutlined, EyeOutlined } from '@ant-design/icons';
import Editor, { type EditorProps } from '@monaco-editor/react';
import { Button, Drawer, Flex, Modal } from 'antd';
import { useState } from 'react';



export const ScriptEditor = (props: EditorProps & { title: string }) => {
  
  // return null
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(false);
  return (
    <>
      <Flex gap={8}>
        <Button block onClick={() => setOpen(true)} icon={<CodeOutlined />}>编辑代码</Button>
        <Button disabled={false} onClick={() => setView(true)}><EyeOutlined /></Button>
      </Flex>
      <Modal
        footer={null}
        width={800}
        open={view}
        onCancel={() => setView(false)}
        title={`预览: ${props.title || ''}`}
      >
        <Editor
          defaultLanguage='javascript'
          height={'400px'}
          theme='vs-dark'
          value={props.value}
          options={{
            // minimap: { enabled: true }, // 建议关闭小地图，否则会占用高度
            readOnly: true,
            scrollBeyondLastLine: false,  // 关键：不要让编辑器滚动到最后一行之外
            automaticLayout: true,       // 自动布局
            scrollbar: {
              vertical: 'auto',          // 垂直滚动条按需出现
            }
          }}
        />
      </Modal>
      <Drawer
        forceRender
        title={props.title}
        size={800}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Flex vertical gap={32} style={{ height: '100%' }}>
          <Flex flex={1}>
            <Editor
              defaultLanguage='javascript'
              height={'100%'}
              theme='vs-dark'
              options={{
                // minimap: { enabled: true }, // 建议关闭小地图，否则会占用高度
                scrollBeyondLastLine: false,  // 关键：不要让编辑器滚动到最后一行之外
                automaticLayout: true,       // 自动布局
                scrollbar: {
                  vertical: 'auto',          // 垂直滚动条按需出现
                }
              }}
              {...props}
            />
          </Flex>
        </Flex>
      </Drawer>
    </>
  );
}